import React from 'react'

function Departments() {
  return (
    <ol className="list-group" style={{ margin: "1em" }}>
      <li className="list-group-item">
        <h5>Bölümler</h5>
      </li>
      <button href="#" className="list-group-item list-group-item-action ">
        Mühendislik
      </button>
      <button href="#" className="list-group-item list-group-item-action ">
        Tıp
      </button>
      <button href="#" className="list-group-item list-group-item-action ">
        Diş Hekimliği
      </button>
      <button href="#" className="list-group-item list-group-item-action ">
        Öğretmenlik
      </button>
    </ol>
  );
}

export default Departments